<template>
  <div class="page-container">
    <h1 class="page-title">{{ t("pages.products.advantages.deliverycapability.title") }}</h1>

    <!-- 内容部分 -->
    <div class="content-section">
      <div class="text-block" v-html="renderContent(t('pages.products.advantages.deliverycapability.introduction.content'))"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// 渲染带有换行的内容
const renderContent = (content: string) => {
  if (!content) return "";
  return content
    .split("\n\n")
    .map((paragraph) => `<p>${paragraph}</p>`)
    .join("");
};
</script>

<style scoped>
@import "@/assets/styles/content-blocks.scss";

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .page-container {
    padding: 30px 15px;
  }
}
</style>